import React from "react"

import globalStyles from "../../../../App.module.scss";
import generate from './images/generate.png'
import check from './images/check.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function PasswordGenerator() {

    let data = `import argparse
import re
import secrets
import string


def generate_password(length: int = 16) -> str:
    alphabet = string.ascii_letters + string.digits + string.punctuation
    return "".join(secrets.choice(alphabet) for _ in range(length))


def check_strength(password: str) -> tuple[str, list[str]]:
    issues = []
    if len(password) < 12:
        issues.append("shorter than 12 characters")
    if not re.search(r"[a-z]", password):
        issues.append("no lowercase letters")
    if not re.search(r"[A-Z]", password):
        issues.append("no uppercase letters")
    if not re.search(r"\\d", password):
        issues.append("no digits")
    if not re.search(r"[^\\w\\s]", password):
        issues.append("no symbols")
    if re.search(r"(.)\\1{2,}", password):
        issues.append("has repeated characters")

    if not issues:
        rating = "strong"
    elif len(issues) <= 2:
        rating = "moderate"
    else:
        rating = "weak"
    return rating, issues


def main():
    parser = argparse.ArgumentParser(description="Generate or check the strength of a password")
    parser.add_argument("--check", help="check an existing password instead of generating one")
    parser.add_argument("--length", type=int, default=16)
    args = parser.parse_args()

    password = args.check or generate_password(args.length)
    rating, issues = check_strength(password)

    if not args.check:
        print(f"Generated password: {password}")

    print(f"Strength: {rating}")
    for issue in issues:
        print(f"  - {issue}")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Password generator &amp; strength checker</h1>
            <p>Generates a random password using the <code>secrets</code> module (safe for security purposes,
                unlike <code>random</code>), or checks the strength of an existing password against a handful of
                simple rules: length, character variety, and repeated characters.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>Generating a new password:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={generate} alt={""}/>
            </div>

            <p>Checking an existing, weaker password:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={check} alt={""}/>
            </div>
        </div>
    )
}
